import { useEffect, useState } from 'react'

import { useNotification, useUserData } from '../../../../hooks'
import { CALENDAR_PREFERENCES_INITIAL } from '../../Calendar.constants'
import {
  getMockCalendarPreferences,
  updateMockCalendarPreferences,
} from '../../Calendar.mock'

export function useCalendarPreferences() {
  const { handleAddErrorNotification } = useNotification()

  const userData = useUserData()

  const [preferences, setPreferences] = useState(CALENDAR_PREFERENCES_INITIAL)
  const [isLoading, setLoading] = useState(true)

  // TODO: read and save the rail through the calendar preferences endpoint
  // once the backend serves it.
  async function readPreferences() {
    return getMockCalendarPreferences(userData.id)
      .then(({ data }) => {
        setPreferences(data)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  async function savePreferences(nextPreferences) {
    return updateMockCalendarPreferences({
      preferences: nextPreferences,
      userId: userData.id,
    }).catch(() => {
      handleAddErrorNotification('Error.CommonApiRequestFailKey')
    })
  }

  function handleChangePreferences(changes) {
    const nextPreferences = { ...preferences, ...changes }

    setPreferences(nextPreferences)

    savePreferences(nextPreferences)
  }

  useEffect(() => {
    readPreferences()
  }, [])

  return { handleChangePreferences, isLoading, preferences }
}
